/**
 * Etiqueta legible de forma de pago: ped_formapago es tpa_id en TipoPago.
 * Evita asumir ids fijos (1=efectivo, 2=tarjeta, 3=cuenta); en BD pueden existir más tipos.
 */
export function getFormaPagoLabel(pedido, tipoPagos = []) {
  if (!pedido) return '—';
  const id = pedido.ped_formapago;
  const tp = tipoPagos.find((t) => Number(t.tpa_id) === Number(id));
  const nombreBase = tp?.tpa_nombre?.trim() || '';

  if (nombreBase) {
    const lower = nombreBase.toLowerCase();
    let extra = '';
    if (lower.includes('cuenta corriente') && pedido.ped_numero_cuenta_corriente) {
      extra = ` - N° ${pedido.ped_numero_cuenta_corriente}`;
    }
    const partesTarjeta = [];
    if (pedido.ped_tarjeta_nombre) partesTarjeta.push(`Nombre: ${pedido.ped_tarjeta_nombre}`);
    if (pedido.ped_tarjeta_banco) partesTarjeta.push(`Banco: ${pedido.ped_tarjeta_banco}`);
    if (pedido.ped_tarjeta_cuotas != null && pedido.ped_tarjeta_cuotas !== '') {
      partesTarjeta.push(`Cuotas: ${pedido.ped_tarjeta_cuotas}`);
    }
    if (partesTarjeta.length) {
      extra += (extra ? ' | ' : ' — ') + partesTarjeta.join(' | ');
    }
    return nombreBase + extra;
  }

  if (Number(id) === 1) return 'Efectivo';
  if (Number(id) === 2) return 'Tarjeta';
  return `Cuenta corriente${pedido.ped_numero_cuenta_corriente ? ` - N° ${pedido.ped_numero_cuenta_corriente}` : ''}`;
}
